import { register } from "marko/components"
import component from "./ss-top-tag.component-browser.js"
register("amtqBz9d", component)